import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';

type PrimeTimesMode = 'general' | 'result';

interface PrimeTimesModeSelectorProps {
  mode: PrimeTimesMode;
  onModeChange: (mode: PrimeTimesMode) => void;
}

export function PrimeTimesModeSelector({ mode, onModeChange }: PrimeTimesModeSelectorProps) {
  useLanguage();
  return (
    <div className="inline-flex gap-2">
      <button
        onClick={() => {
          onModeChange('general');
          console.log('peaks_mode_changed', { mode: 'dados_gerais' });
        }}
        className={cn(
          "px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-150",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          mode === 'general'
            ? "bg-[#2D6CF6] text-white shadow-sm"
            : "bg-white text-[#5F6C7B] border border-[#E5E7EB] hover:bg-[#F9FAFB] hover:border-[#93C5FD]"
        )}
      >
        {translateInterfaceText("Dados Gerais")}</button>
      <button
        onClick={() => {
          onModeChange('result');
          console.log('peaks_mode_changed', { mode: 'resultado' });
        }}
        className={cn(
          "px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-150",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
          mode === 'result'
            ? "bg-[#2D6CF6] text-white shadow-sm"
            : "bg-white text-[#5F6C7B] border border-[#E5E7EB] hover:bg-[#F9FAFB] hover:border-[#93C5FD]"
        )}
      >
        {translateInterfaceText("Conversão")}</button>
    </div>
  );
}
